import React, { useState, useRef, useEffect } from "react";
import { NXPrint } from "../../icons";
import { useLazyQuery } from "@apollo/client";
import { generateBulkInvoice, GET_INVOICES } from "../../pdf/generateBulkInvoice";
import { generateBulkReceiptPOS } from "../../pdf/generateBulkReceiptPOS";
import InvoiceChooser from "./invoiceChooser";

interface OrderPrintButtonProps {
    order_id: string;
}

const OrderPrintButton: React.FC<OrderPrintButtonProps> = ({ order_id }) => {
    const [fetchInvoices, { data, loading, error }] = useLazyQuery(GET_INVOICES);
    const [isOpen, setIsOpen] = useState(false);

    const [openInvoiceChooser, setOpenInvoiceChooser] = useState<boolean>(false);
    const [printInvoice, setPrintInvoice] = useState<any>(null);
    const [printReceipt, setPrintReceipt] = useState<any>(null);

    const dropdownRef = useRef<HTMLDivElement>(null);


    useEffect(() => {
        if (data) {
          if (printInvoice) {
            generateBulkInvoice(data);
            setPrintInvoice(false);
          }
    
          if (printReceipt) {
            generateBulkReceiptPOS(data);
            setPrintReceipt(false);
          }
    
        }
      }, [data]);

    

  

    return (
        <div className="relative" ref={dropdownRef}>
            {/* Button to toggle dropdown */}
            <button
                className="bg-gray-600 text-white text-sm px-4 py-2 rounded-lg hover:bg-gray-700 transition duration-200 md:w-auto w-full flex items-center justify-center space-x-2 border border-gray-400"
                onClick={() => setIsOpen(!isOpen)}
            >
                <NXPrint className="hover:stroke-primary-400 cursor-pointer transition-all duration-150 ease-linear" />
                <span>Print</span>
            </button>

            {/* Dropdown Menu */}
            {isOpen && (
                <div className="absolute left-0 mt-2 bg-white shadow-lg rounded-lg w-48 z-10">
                    <button
                        className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                        onClick={() => {
                            fetchInvoices({ variables: { orderIds: [order_id] } });
                            setPrintInvoice(true);
                        }}
                    >
                        Print Invoice
                    </button>
                    <button
                        className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                        onClick={() => {
                            setOpenInvoiceChooser(true);
                        }}
                    >
                        Print Invoice As
                    </button>
                    <button
                        className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                        onClick={() => {
                            fetchInvoices({ variables: { orderIds: [order_id] } });
                            setPrintReceipt(true);
                        }}
                    >
                        Print Receipt
                    </button>
                </div>
            )}

        { openInvoiceChooser && <InvoiceChooser selectedItems={[order_id]} isOpen={openInvoiceChooser} onClose={() =>  setOpenInvoiceChooser(false) } />}

        </div>
    );
};

export default OrderPrintButton;
